import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, OnChanges, SimpleChanges} from '@angular/core';
import * as moment from 'jalali-moment';
import {DatePickerShamsi} from './date-picker-shamsi';

@Component({
  selector: 'app-date-picker-shamsi',
  templateUrl: './date-picker-shamsi.component.html',
  styleUrls: ['./date-picker-shamsi.component.scss']
})
export class DatePickerShamsiComponent implements OnInit, OnDestroy, OnChanges {
  @Output() skyWlak: EventEmitter<any> = new EventEmitter<any>();
  @Input() config: DatePickerShamsi;
  // azade
  @Input() showStar = false;
  @Input() isEmpty = false;
  @Input() myDate = '';
  @Input() isEndDate = false;
  @Input() isReset = false;
  @Input() hasErr: boolean;

  changed;
  sign = 1;
  dataTimeShamsi = [];
  dialogIsOpen = false;
  iosDate: Array<number>;
  data = [
    {
      currentIndex: 1,
      weight: 0,
      list: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30]
    },
    {
      currentIndex: 1,
      weight: 0,
      list: ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور', 'مهر', 'آبان', 'آذر', 'دی', 'بهمن', 'اسفند']
    },
    {
      currentIndex: 1,
      weight: 0,
      list : []
    }
  ];
  @Input() anotherDate = false;
  constructor() {
    this.config = new DatePickerShamsi();
    this.iosDate = [];
  }
  ngOnChanges(): void {
    if (this.isReset) {
      this.hasErr = false;
      this.dataTimeShamsi[0] = '';
      this.dataTimeShamsi[1] = '';
      this.dataTimeShamsi[2] = '';
      this.initDatePicker();
    }
  }

  ngOnInit(): void {
    this.createDate();
    this.initDatePicker();
    if (this.myDate !== null && this.myDate !== '') {
      const temp = moment.unix(Number(this.myDate) / 1000).locale('fa').format('YYYY/MM/DD').split('/');
      this.data[0].currentIndex = parseInt(temp[2], 0) - 1;
      this.data[1].currentIndex = parseInt(temp[1], 0) - 1;
      this.data[2].currentIndex = this.data[2].list.findIndex(x => {
        return x === parseInt(temp[0], 0);
      });
      this.iosDate[0] = parseInt(temp[2], 0);
      this.iosDate[1] = parseInt(temp[1], 0);
      this.iosDate[2] = parseInt(temp[0], 0);
      this.setDate();
    }
  }
  initDatePicker() {
    const m = moment();
    const e = m.locale('fa').format('YYYY/MM/DD').split('/');
    this.data[0].currentIndex = parseInt(e[2], 0) - 1;
    this.data[1].currentIndex = parseInt(e[1], 0) - 1;
    this.data[2].currentIndex = this.data[2].list.findIndex(x => {
      return x === parseInt(e[0], 0);
    });
    this.iosDate[0] = parseInt(e[2], 0);
    this.iosDate[1] = parseInt(e[1], 0);
    this.iosDate[2] = parseInt(e[0], 0);
    this.changed = Math.random();
    if (this.iosDate[1] < 7) {
      this.data[0].list[30] = 31;
    }
  }
  createDate() {
    const date = new Date();
    this.config.startYaer = Number(moment.unix(date.getTime() / 1000).locale('fa').format('YYYY'));
    this.data[2].list = [];
    this.sign = 1;
    let numbers = this.config.count;
    if (numbers < 0) {
      numbers = Math.abs(this.config.count);
      this.sign = -1;
    }
    if (this.config.middle) {
      this.config.startYaer = this.config.startYaer - this.config.count / 2 + 1;
      this.sign = 1;
      this.data[2].currentIndex = this.data[2].list.length / 2 - 1;
    }
    for (let i = 0 ; i < numbers ; i++ ) {
      const temp = this.config.startYaer + (i * this.sign);
      this.data[2].list[i] = temp;
    }
    if (this.sign === -1) {
      this.data[2].list.reverse();
      this.data[2].currentIndex = this.data[2].list.length - 1;
      this.config.startYaer = Number(this.data[2].list[0]);
    }
  }
  ngOnDestroy() {
    this.dialogIsOpen = false;
  }
  dateChanged({ gIndex, iIndex }) {
    if (gIndex === 0) {
      this.iosDate[0] = iIndex + 1;
    }
    if (gIndex === 1) {
      this.iosDate[1] = iIndex + 1;
      if (this.iosDate[1] < 7) {
        this.data[0].list[30] = 31;
      } else {
        if (this.data[0].list[30]) {
          this.data[0].list.pop();
        }
      }
    }
    if (gIndex === 2) {
      this.iosDate[2] = this.config.startYaer + (iIndex);
    }
  }
  setDate() {
    this.dataTimeShamsi[0] = (this.iosDate[0] > 9) ? this.iosDate[0] : `0${this.iosDate[0]}`;
    this.dataTimeShamsi[1] = (this.iosDate[1] > 9) ? this.iosDate[1] : `0${this.iosDate[1]}`;
    this.dataTimeShamsi[2] = this.iosDate[2];
    this.dialogIsOpen = false;
    this.hasErr = false;
    this.emitDateTime();
  }
  closeDialog() {
    this.dialogIsOpen = false;
  }
  nextSiblin(event, maxLength, last?): void {
    if (event.code === 'Backspace') {
      if (!this.hasErr) {
        this.hasErr = this.validateTypedDate();
        if (this.hasErr) {
          this.skyWlak.emit(false);
        }
      }
      if (event.target.value.length === 0) {
        if (this.dataTimeShamsi[0] === undefined && this.dataTimeShamsi[1] === undefined && this.dataTimeShamsi[2] === undefined) {
          this.hasErr = false;
          this.emitDateTime(true);
        }
      }
    } else {
      this.hasErr = this.validateTypedDate();
      if (!last) {
        // if (event.target.value.length === maxLength) {
        //   event.target.nextSibling.nextSibling.focus();
        // }
      } else {
        if (!this.hasErr) {
          this.data[0].currentIndex = parseInt(this.dataTimeShamsi[0], 0) - 1;
          this.data[1].currentIndex = parseInt(this.dataTimeShamsi[1], 0) - 1;
          this.data[2].currentIndex = this.data[2].list.findIndex(x => {
            return x === parseInt(this.dataTimeShamsi[2], 0);
          });
          this.changed = Math.random(); //this.data[0].currentIndex + this.data[1].currentIndex + this.data[2].currentIndex;
          this.emitDateTime();
        }
      }
    }

  }
  checkAllValidation() {
    if (this.dataTimeShamsi[0] === '' && this.dataTimeShamsi[1] === '' && this.dataTimeShamsi[2] === '') {
      this.initDatePicker();
      this.hasErr = false;
      this.changed = Math.random(); // this.data[0].currentIndex + this.data[1].currentIndex + this.data[2].currentIndex;
      this.emitDateTime(true);
    }
    if (this.dataTimeShamsi[0] && this.dataTimeShamsi[1] && this.dataTimeShamsi[2]) {
      this.hasErr = this.validateTypedDate();
      if (!this.hasErr) {
        this.emitDateTime();
      }
    }
  }
  emitDateTime(isCancel = false) {
    if (isCancel) {
      this.skyWlak.emit('');
    } else {
      const jDate = `${this.dataTimeShamsi[2]}/${this.dataTimeShamsi[1]}/${this.dataTimeShamsi[0]}`;
      let timeStamp = moment(jDate, 'jYYYY/jMM/jDD').valueOf();
      if (this.isEndDate) {
        const c = new Date(timeStamp);
        c.setHours(23, 59, 59, 999);
        timeStamp = c.getTime();
      }
      this.skyWlak.emit(timeStamp);
    }
  }
  validateTypedDate() {
    this.dataTimeShamsi[2] = this.convertToEnglishNumber(this.dataTimeShamsi[2]);
    this.dataTimeShamsi[1] = this.convertToEnglishNumber(this.dataTimeShamsi[1]);
    this.dataTimeShamsi[0] = this.convertToEnglishNumber(this.dataTimeShamsi[0]);
    if (this.dataTimeShamsi[0] === undefined || this.dataTimeShamsi[1] === undefined || this.dataTimeShamsi[2] === undefined) {
      return true;
    }
    const year = parseInt(this.dataTimeShamsi[2], 0);
    const month = parseInt(this.dataTimeShamsi[1], 0);
    const day = parseInt(this.dataTimeShamsi[0], 0);
    if (month > 6 && day > 30) {
      this.hasErr = true;
      return true;
    }
    if (year && month && day) {
      const minYear = this.data[2].list[0];
      const maxYear = this.data[2].list[this.data[2].list.length - 1];
      this.hasErr = (year > maxYear || year < minYear) || (month > 12 || month < 1) || (day > 31 || day < 1);
      return this.hasErr;
    }
  }
  checkDayOfMonth() {
    const month = parseInt(this.dataTimeShamsi[1], 0);
    const day = parseInt(this.dataTimeShamsi[0], 0);
    if (month > 6 ) {
      if (day > 30) {

      }
    }
  }
  convertToEnglishNumber(value) {
    if (!value) {
      return;
    }
    const temp = [];
    let result = '';
    for (let i = 0; i < value.length; i++) {
      if (value.charCodeAt(i) > 1000) {
        const x = value.charCodeAt(i) - 1728;
        temp[i] = String.fromCharCode(x);
      } else {
        temp[i] = value[i];
      }
    }
    if (temp.length === value.length) {
      // tslint:disable-next-line: prefer-for-of
      for (let i = 0; i < temp.length; i++) {
        result += temp[i];
      }
    } else {
      result = value;
    }
    return result;
  }
}
